import React, { FC, SVGAttributes } from "react"

const RightIcon: FC<SVGAttributes<SVGElement>> = ({ ...props }) => {
    return <svg
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M17 8l4 4m0 0l-4 4m4-4H3"
        />
    </svg>
}

export default RightIcon
